import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import Stats from './components/Stats';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Safetysoftware from './components/Safetysoftware';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Courses from './components/Courses';
import Elearning from './components/Elearning';
import Equipment from './components/Equipment';
import FloatingIcon from './components/FloatingIcon';



const App = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Services />
      <Courses />
      {/* <Elearning /> */}
      <Equipment />
      <Stats />
      <About />
      <Safetysoftware />
      {/* <Testimonials /> shotdown temporary*/}
      <Contact />
      <Footer />
      <FloatingIcon />
    </div>
  );
};

export default App;